module.exports = __webpack_public_path__ + "img/icon_end-user.9b30e8fb.svg";